import { ROUTES } from "../utils/constants";

const authConfig = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  onboardingRedirectPath: `/onboarding/${ROUTES.ONBOARDING.LOGGING_IN}`,
  fallbackRedirectPath: `/onboarding/${ROUTES.ONBOARDING.SIGN_UP}`,
};

export default authConfig;
